export default __webpack_public_path__ + "static/media/Eye.2e4bb9fe.svg";